// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__FCw74","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3ZlCV"};